
import { computed, defineComponent } from "vue";
import Config from "@/core/config/ApiConfig";

export default defineComponent({
  name: "inline-svg-icon",
  props: {
    src: { type: String, required: true },
  },
  setup(props) {
    const svgUrl = computed(() => {
      return Config.cdnUrl + "/" + props.src;
    });

    return {
      svgUrl,
    };
  },
});
